export default __webpack_public_path__ + "static/media/panda-joy-jump.185c168b.gif";